import React, { useEffect, useState } from 'react';
import { Chip, IconButton, Tooltip } from '@mui/material';
import { LockOpenOutlined } from '@mui/icons-material';
import { bacaLaci } from '../../struk/laciKasir';
import { catatBukaLaci } from '../../utils/catatCetak';
import { fetchCabangConfig } from './productpercabang/apiProductPercabang';

/**
 * Tombol "Buka Laci" untuk kasir web. Tampil hanya bila cabang mengaktifkan laci kasir (Struk > Laci Kasir). Perintah dikirim lewat
 * printer Bluetooth yang tersambung; tiap tekan dicatat PENTING di Log Aktivitas. Laci tidak bisa dibuka lewat jendela cetak browser.
 * konfigurasi boleh diberikan induk; bila tidak, dibaca sendiri dari server.
 */
const TombolBukaLaci = ({ printer, cabangUuid, konfigurasi = null, varian = 'ikon', onPesan }) => {
  const [dibaca, setDibaca] = useState(null);

  useEffect(() => {
    if (konfigurasi || !cabangUuid) return undefined;
    let batal = false;
    fetchCabangConfig(cabangUuid).then((k) => { if (!batal) setDibaca(k); }).catch(() => {});
    return () => { batal = true; };
  }, [konfigurasi, cabangUuid]);

  const laci = bacaLaci(konfigurasi || dibaca);
  if (!laci.aktif) return null;

  const buka = async () => {
    if (!printer || typeof printer.bukaLaci !== 'function') {
      onPesan?.('warning', 'Hubungkan printer Bluetooth dulu supaya laci bisa dibuka.');
      return;
    }
    try {
      await printer.bukaLaci(laci.pin);
      catatBukaLaci();
      onPesan?.('success', 'Perintah buka laci dikirim.');
    } catch (error) {
      onPesan?.('error', error?.message || 'Gagal membuka laci kasir. Periksa sambungan printer.');
    }
  };

  if (varian === 'chip') {
    return (
      <Chip
        icon={<LockOpenOutlined sx={{ fontSize: 16 }} />}
        label="Buka Laci"
        variant="outlined"
        size="small"
        onClick={buka}
        sx={{ width: '100%', justifyContent: 'flex-start', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', mt: 1 }}
      />
    );
  }
  return (
    <Tooltip title="Buka laci kasir">
      <IconButton onClick={buka} aria-label="Buka laci kasir" sx={{ color: printer ? '#42526e' : '#97a0af' }}>
        <LockOpenOutlined />
      </IconButton>
    </Tooltip>
  );
};

export default TombolBukaLaci;
